import { render, staticRenderFns } from "./SSelectDistrict.vue?vue&type=template&id=778d2fb5"
import script from "./SSelectDistrict.vue?vue&type=script&lang=js"
export * from "./SSelectDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports